import React, { useEffect, useState } from "react";
import styles from "./PreviewVideo.module.scss";
import { ReactComponent as MoreInfoIcon } from "assets/svg/InformationIcon.svg";
import { ReactComponent as CrossIcon } from "assets/svg/x.svg";
import OptionsModal from "components/shared/modal/OptionsModal/OptionsModal";
import CameraCaptureModal from "components/shared/modal/CameraCapture/CameraCaptureModal";
import InputTextArea from "components/shared/textArea/InputTextArea";
import { useForm } from "react-hook-form";
import CheckIcon from "@mui/icons-material/Check";
import VideoCameraBackOutlinedIcon from "@mui/icons-material/VideoCameraBackOutlined";
import attach_vid from "../../../../../assets/svg/attach_vid.svg"
const PreviewVideo = (props) => {
  const [showIcon, setShowIcon] = useState(
    props?.data?.showInstructions || false
  );
  const [imageGalleryData, setImageGalleryData] = useState("");
  const [imageData, setImageData] = useState([]);
  const [optionModalOpen, setOptionModalOpen] = useState(false);
  const [cameraModalOpen, setCameraModalOpen] = useState(false);
  const { control } = useForm({});

  return (
    <div className={styles.mainContainer}>
      <div className={styles.mainContent}>
        <div className={styles.heading}>
          <div className={styles?.rightSide}>
            <span>
              {" "}
              {props?.data?.required && <span style={{ color: "red" }}>*</span>}
              {props?.data?.value || props?.name || props?.label}
            </span>
          </div>
          {props?.instructions || props?.data?.media?.length ? (
            <div>
              {showIcon ? (
                <CrossIcon onClick={() => setShowIcon((prev) => !prev)} />
              ) : (
                <MoreInfoIcon onClick={() => setShowIcon((prev) => !prev)} />
              )}
            </div>
          ) : null}
        </div>
        <div className={styles.rightContainer}>
          {imageData?.length > 0 || imageGalleryData ? (
            <div className={styles.photoAndAdd}>
              <CheckIcon />
              <div
                className={styles.AddimageButton}
                onClick={() => setOptionModalOpen(true)}
              >
                <img src={attach_vid} alt="video" className={styles.cameraicon} />
                {/* <VideoCameraBackOutlinedIcon className={styles.cameraicon} /> */}
                <p>Change Video</p>
              </div>
            </div>
          ) : (
            <div
              className={styles.AddimageButton}
              onClick={() => setOptionModalOpen(true)}
            >
              <p>Add Video</p>
              <img src={attach_vid} alt="video" className={styles.cameraicon} />
              {/* <VideoCameraBackOutlinedIcon className={styles.cameraicon} /> */}

            </div>
          )}
          <div className={styles.textAreaField}>
            <InputTextArea
              control={control}
              type="textarea"
              name="Optional"
              placeholder="Note or Caption"
              onChange={(e) => e}
              className={styles.textArea}
            />
          </div>
        </div>


        {/* <div className={styles.inputText}>
          <input
            className={styles.textField}
            placeholder='text'
          />
        </div> */}
      </div>
      {showIcon && (
        <div className={styles.subContent}>
          {props?.instructions && (
            <div className={styles.instructionText}>
              {props?.instructions}
            </div>
          )}
          {props?.data?.media?.length ? (
            <>
              {props?.data?.media.map((image) => (
                <img
                  className={styles.imageStyle}
                  src={image.path}
                  style={{ width: "100px", height: "100px" }}
                  alt="Preview"
                />
              ))}
            </>
          ) : null}
        </div>
      )}

      <OptionsModal
        optionModalOpen={optionModalOpen}
        setOptionModalOpen={setOptionModalOpen}
        setCameraModalOpen={setCameraModalOpen}
        setImageData={setImageData}
        setImageGalleryData={setImageGalleryData}
        video={true}
      />
      {cameraModalOpen && (
        <CameraCaptureModal
          video={true}
          setCameraModalOpen={setCameraModalOpen}
          cameraModalOpen={cameraModalOpen}
          setImageData={setImageData}
          imageData={imageData}
        />
      )}
    </div>
  );
};

export default PreviewVideo;
